import { Dropdown, Field, Hint, Item, Label, Menu, Multiselect } from "@zendeskgarden/react-dropdowns";
import { ReactElement, useEffect, useRef, useState } from "react";

import * as css from "./styles/acquisitionPropertyFormStyles.module.scss";
import { Message } from "@zendeskgarden/react-forms";
import { Tag } from "@zendeskgarden/react-tags";


export type TAcquisitionPropertyMultiselectOption = {
    name: string;
    value: string;
}

export interface IAcquisitionPropertyFormMultiselect {
    label: string,
    required?: boolean,
    selection: string[],
    options: TAcquisitionPropertyMultiselectOption[],
    error?: string,
    onSelect: (items: string[]) => void,
    downshiftProps?: any,
}

export default function AcquisitionPropertyFormMultiselect(props: IAcquisitionPropertyFormMultiselect): ReactElement {
    const {
        label,
        required = false,
        selection,
        options,
        onSelect,
        error,
        downshiftProps,
    } = props;

    const [inputValue, setInputValue] = useState('');
    const [matchingOptions, setMatchingOptions] = useState(options);

    useEffect(() => {
        const t = setTimeout(() => {
            if(!inputValue) {
                setMatchingOptions([...options]);
                return;
            }

            const matchedOptions = options.filter(option => {
                return option.name.trim().toLowerCase().indexOf(inputValue.trim().toLowerCase()) !== -1;
            });

            setMatchingOptions(matchedOptions);
        }, 300);

        return () => clearTimeout(t);
    }, [inputValue]);

    function renderOptions() {
        return matchingOptions.map((option, index) => {
            return (
                <Item key={index} value={option.value}>
                    {option.name}
                </Item>
            );
        });
    }

    return (
        <Dropdown
            downshiftProps={downshiftProps}
            onSelect={onSelect}
            selectedItems={selection}
            onInputValueChange={value => setInputValue(value)}
        >
            <Field>
                <Label className={css.acquisitionPropertyFormLabel}>
                    <span>{label}</span>
                    {required && <span className={css.required}>REQUIRED</span>}
                </Label>
                <Hint>Admins automatically have access to all Acquisition Properties</Hint>
                <Multiselect
                    renderItem={({ value, removeValue }: any) => (
                        <Tag>
                            <span>{options.find(x => x.value == value)?.name}</span>
                            <Tag.Close onClick={() => removeValue()} />
                        </Tag>
                    )}
                />
                {error && <Message validation="error">{error}</Message>}
            </Field>
            <Menu>
                {renderOptions()}
            </Menu>
        </Dropdown>
    );
}
